import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'reactstrap'
import ReportModel from 'models/report.modal';
import Loader from "components/loader/Loader";

const Revenue = () => {
  const [data, setData] = useState();

  // Dummy data for revenue
  const dummyRevenue = {
    last7DaysRevenue: {
      totalMargin: 12000,
      totalPriceTutor: 8000,
    },
    marginPercentage7Days: 15,
    last28DaysRevenue: {
      totalMargin: 45000,
      totalPriceTutor: 32000,
    },
    marginPercentage28Days: -5,
    invoiceThisYear: {
      totalAmount: 210000,
    }
  };

  const List = async () => {
    ReportModel.Revenuelist()
      .then((responce) => {
        setData(responce);
      })
      .catch((error) => {
        // Use dummy data if API fails
        setData(dummyRevenue);
      });
  };

  useEffect(() => {
    List();
  }, []);

  return (
    <Container className="pt-7">
      <div style={{ width: '80%', margin: '0 auto', padding: '20px', background: '#fff', borderRadius: '10px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
        <Row className='pl-2 pr-2'>Revenue</Row>
        <Row className='mt-4 mb-4'>
          <Col xs={12} md={3} className=' d-flex flex-column mb-3 mb-md-0'>
            <span style={{ fontSize: "14px", fontWeight: "bold" }}>7 day Revenew</span>
            <div style={{ fontSize: "32px", fontWeight: "bolder", display: "flex", alignItems: "center" }}>&#8377;{data?.last7DaysRevenue?.totalMargin} </div>
            <span style={{ fontSize: "14px", fontWeight: "bold" }}> {data?.marginPercentage7Days > 0 ? "\u25B2" : "\u25BC"} {data?.marginPercentage7Days}%</span>
            <span style={{ fontSize: "13px" }} >vs the previous 7 days</span>
          </Col>
          <Col xs={12} md={3} className=' d-flex flex-column mb-3 mb-md-0'>
            <span style={{ fontSize: "14px", fontWeight: "bold" }}>28 Day Revenew</span>
            <span style={{ fontSize: "32px", fontWeight: "bolder", display: "flex" }}>&#8377; {data?.last28DaysRevenue?.totalMargin} </span>
            <span style={{ fontSize: "14px", fontWeight: "bold" }}> {data?.marginPercentage28Days > 0 ? "\u25B2" : "\u25BC"} {data?.marginPercentage28Days}%</span>
            <span style={{ fontSize: "13px" }} >vs the previous 28 days </span>
          </Col>
          <Col xs={12} md={3} className=' d-flex flex-column mb-3 mb-md-0'>
            <span style={{ fontSize: "14px", fontWeight: "bold" }}>Invoiced this year</span>
            <span style={{ fontSize: "32px", fontWeight: "bolder" }}>{data?.invoiceThisYear?.totalAmount}</span>
          </Col>
          <Col xs={12} md={3} className=' d-flex flex-column mb-3 mb-md-0'>
            <span style={{ fontSize: "14px", fontWeight: "bold" }}>Total Tutors Salary Owed</span>
            <span style={{ fontSize: "32px", fontWeight: "bolder" }}>&#8377; {data?.last28DaysRevenue?.totalPriceTutor}</span>
          </Col>
        </Row>
      </div>
    </Container>
  )
}

export default Revenue